<template>
    <div class="consult-page">
        <ConsultSection></ConsultSection>
    </div>
</template>

<script>
import ConsultSection from './ConsultSection.vue';
export default {
  name: "ConsultPage",
  components: {
    ConsultSection,
  },
  setup() {


    return {};
  },
};
</script>

<style scoped>
.consult-page {
    margin-block: 100px 200px;
}

@media screen and (max-width: 1024px) {
    .consult-page {
        margin-top: 65px;
    }
}

@media screen and (max-width: 768px) {
    .consult-page {
        margin-block: 0 160px;
    }
}
</style>